export function calcSize(srcWidth, srcHeight, newWidth, newHeight, flags = 0) {
  newWidth = Math.abs(newWidth)
  newHeight = Math.abs(newHeight);

  if (flags === 8 || flags === 16) {
    if (!newWidth || !newHeight) {
      throw 'For exact size must be both width and height specified.'
    }

    return [newWidth, newHeight]
  }

  if (flags & 2) { // non-proportional STRETCH
    if (!newWidth || !newHeight) {
      throw 'For stretching must be both width and height specified.'
    }

    if (flags & 1) {
      newWidth =  Math.round(srcWidth * Math.min(1, newWidth / srcWidth))
      newHeight = Math.round(srcHeight * Math.min(1, newHeight / srcHeight))
    }

  } else {  // proportional
    if (!newWidth && !newHeight) {
      throw 'At least width or height must be specified.'
    }

    let scale = []
    if (newWidth > 0) { // fit width
      scale.push(newWidth / srcWidth)
    }

    if (newHeight > 0) { // fit height
      scale.push(newHeight / srcHeight)
    }

    if (flags & 4) {
      scale = [Math.max(...scale)]
    }

    if (flags & 1) {
      scale.push(1);
    }

    scale = Math.min(...scale)
    newWidth = Math.round(srcWidth * scale)
    newHeight = Math.round(srcHeight * scale)
  }

  return [Math.max(newWidth, 1), Math.max(newHeight, 1)]
}

// size formats
// 400x
// x400
// 400x400
// 400x400x16
// 400x400x1xWHATEVER
export default function getImageSize(image, size) {
  if (size === 'original')
    return [image.width, image.height]

  const sizeArr = size.split('x', 4)
  if (sizeArr.length < 2)
    return

  let flags = 1
  let newWidth = 0
  let newHeight = 0
  if (Number.isInteger(parseInt(sizeArr[0])) && sizeArr[1] === '') { // 400x
    newWidth = parseInt(sizeArr[0])
    newHeight = 10000
  } else if (Number.isInteger(parseInt(sizeArr[1])) && sizeArr[0] === '') { // x400
    newWidth = 10000
    newHeight = parseInt(sizeArr[1])
  } else if (Number.isInteger(parseInt(sizeArr[0])) && Number.isInteger(parseInt(sizeArr[1]))) { // 400x400
    newWidth = parseInt(sizeArr[0])
    newHeight = parseInt(sizeArr[1])
  } else {
    return
  }

  if (sizeArr[2] && Number.isInteger(parseInt(sizeArr[2]))) {
    flags = parseInt(sizeArr[2])
  }

  return calcSize(image.width, image.height, newWidth, newHeight, flags)
}